<script>
import { Pie } from 'vue-chartjs'
import 'chartjs-plugin-labels'

export default {
  name: 'MeetingFrequencyGraph',
  extends: Pie,
  props: {
    meetingsAtPrimaryOffice: {
      type: String,
      default: '0',
    },
    meetingsAtSecondaryOffice: {
      type: String,
      default: '0',
    },
    meetingsAtClientHome: {
      type: String,
      default: '0',
    },
    meetingsAtClientOffice: {
      type: String,
      default: '0',
    },
  },

  data: () => ({
    graphData: {
      labels: [
        'Primary Office',
        'Secondary Office',
        'Client\'s Home',
        'Client\'s Office',
      ],
      datasets: [{
        data: [],
        backgroundColor: [
          '#97C932',
          '#0093A3',
          '#5E5E60',
          '#E55440',
        ],
        borderWidth: 0,
      }],
    },
    graphOptions: {
      plugins: {
        labels: {
          outsidePadding: 0,
        },
      },
      maintainAspectRatio: false,
      responsive: true,
      legend: {
        display: false,
      },
      tooltips: {
        enabled: false,
      },
    },
  }),

  watch: {
    meetingsAtPrimaryOffice () { this.render() },
    meetingsAtSecondaryOffice () { this.render() },
    meetingsAtClientHome () { this.render() },
    meetingsAtClientOffice () { this.render() },
  },

  mounted () {
    this.render()
  },

  methods: {
    render () {
      this.graphData.datasets[0].data = [
        Number(this.meetingsAtPrimaryOffice),
        Number(this.meetingsAtSecondaryOffice),
        Number(this.meetingsAtClientHome),
        Number(this.meetingsAtClientOffice),
      ]

      this.renderChart(this.graphData, this.graphOptions)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/buyer-listing-details-as-pdf/partials/MeetingFrequencyGraph.vue